class HeaderInfoTooltipEvent {
  static HIDE = 'tooltipHide';
}

export default HeaderInfoTooltipEvent;
